<div class="security-studies-card content-center">
    <div *ngIf="!securityStudiesEnabled" class="security-disabled-message content-center">
        <div class="content-center title-component text-center">
            ESTUDIOS DE SEGURIDAD
        </div>
        <div class="alert alert-info text-center">
            <i class="fas fa-info-circle me-2"></i>
            Usted no tiene habilitado los estudios de seguridad
        </div>
    </div>
    <ng-container *ngIf="securityStudiesEnabled">
        <div *ngIf="securityStudiesEnabled === true" class="content-center title-component text-center">
            ESTUDIOS DE SEGURIDAD
        </div>
        <div class="status-header d-flex justify-content-end" *ngIf="vehicle && vehicle.driver">
            <!-- Tooltip on the wrapper: .disabled uses pointer-events:none, so hover never reaches the <a> -->
            <div [matTooltip]="!hasPermissionToManageSecurityStudy ? missingSecurityStudyPermissionTooltip : ''"
                matTooltipClass="tooltip__alert">
                <a class="generate-link" (click)="openSecurityStudyVehicleAndDriver()"
                    [class.disabled]="!hasPermissionToManageSecurityStudy || !isEnabledSecurityStudy('Vehicle') || isSpecificStudyInProgress('Vehicle') || !isEnabledSecurityStudy('Driver') || isSpecificStudyInProgress('Driver')">
                    <span class="text-wrap-balance">Generar estudio vehiculo y conductor </span>
                </a>
            </div>
        </div>
        <ng-container *ngFor="let studyCard of studyCards">
            <div class="content-center status-row mb-2" *ngIf="canVisualizeStudyCard(studyCard.show)">
                <div class="status-item">
                    <div class="status-header">
                        <div class="status-label">Estado del {{ studyCard.alias }}</div>
                        <div [matTooltip]="!hasPermissionToManageSecurityStudy ? missingSecurityStudyPermissionTooltip : ''"
                            matTooltipClass="tooltip__alert"
                            *ngIf="!hasStatePending(studyCard.name) || (hasStatePending(studyCard.name) && isSpecificStudyInProgress(studyCard.name))">
                            <a class="generate-link" (click)="openSecurityStudy(studyCard.name)"
                                [class.disabled]="!hasPermissionToManageSecurityStudy || !isEnabledSecurityStudy(studyCard.name) || isSpecificStudyInProgress(studyCard.name) || hasStatePending(studyCard.name)">
                                Generar estudio
                            </a>
                        </div>
                        <div [matTooltip]="!hasPermissionToManageSecurityStudy ? missingSecurityStudyPermissionTooltip : ''"
                            matTooltipClass="tooltip__alert"
                            *ngIf="hasStatePending(studyCard.name) && !isSpecificStudyInProgress(studyCard.name)">
                            <a class="generate-link" (click)="finalizeStudyTruora(studyCard.name)"
                                [class.disabled]="!hasPermissionToManageSecurityStudy || !isEnabledSecurityStudy(studyCard.name)">
                                Finalizar estudio
                            </a>
                        </div>
                    </div>
                    <div class="status-info">
                        <div class="security-status-card">
                            <div class="status-container">
                                <div class="status-indicator">
                                    <div [ngClass]="getStudyStatus(studyCard.name).color" class="status-circle">
                                    </div>
                                    <div class="status-message">{{ getStudyStatus(studyCard.name).message }}</div>
                                </div>
                                <i *ngIf="canVisualizeTypeAndPdf(studyCard.name) && getCheckId(studyCard.name)"
                                    class="far fa-file-pdf" [ngClass]="getPdfIconClass(studyCard.name)"
                                    (click)="visualizePDF(studyCard.name)"></i>
                            </div>
                        </div>
                    </div>
                    <div class="timer-bar" *ngIf="countdowns[studyCard.value] > 0">
                        <div class="timer-content">
                            <span class="timer-icon">
                                <i class="fas fa-hourglass-half"></i>
                            </span>
                            <span>Tiempo restante: {{ getFormattedCountdown(studyCard.value) }}</span>
                        </div>
                    </div>
                    <div class="alert p-1 text-center text-bold" role="alert"
                        [ngClass]="isStudyConjoined(studyCard.name).class"
                        *ngIf="canVisualizeTypeAndPdf(studyCard.name)">
                        <small class="text-center">{{ isStudyConjoined(studyCard.name).message }}</small>
                        <div class="separator_center width-separator"
                            *ngIf="getStudyDate(studyCard.name) || getExpeditionDate(studyCard.name)"></div>
                        <!--<small class="study-date text-center" *ngIf="getStudyDate(studyCard.name)">
                            Fecha de generación
                            <i class="fas fa-info-circle"
                                matTooltip="Fecha en que se solicitó/generó el estudio de seguridad en la plataforma"></i>:
                            {{ getStudyDate(studyCard.name) }}</small>
                        <br>-->
                        <small class="study-date text-center" *ngIf="getExpeditionDate(studyCard.name)">
                            Fecha de expedición
                            <i class="fas fa-info-circle"
                                matTooltip="Fecha en que Truora expidió el documento del check del estudio"></i>:
                            {{ getExpeditionDate(studyCard.name) }}</small>
                    </div>
                </div>
            </div>
        </ng-container>
    </ng-container>
</div>